<template>
    <div>
        <div v-if="str || apiFailed" class="app-container">
            <div v-if="data.length && !apiFailed && hideTitle === false" class="app-title">
                {{ str['contents'] }}
            </div>
            <div v-if="notes && notes.length" class="app-notes">
                <div
                    v-for="(note, index) in notes"
                    :key="index"
                >
                    {{ str[note.label] ? str[note.label] : note.label }}
                </div>
            </div>
            <div v-if="data.length" class="app-cards">
                <div v-for="item in data" :key="item.value">
                    <v-card class="cursor-hover" @click="openItem(item)">
                        <v-img
                            :src="item.image"
                            class="align-end"
                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            height="200px"
                            cover
                        >
                            <v-card-title>
                                <div>
                                    {{ str[item.label] ? str[item.label] : item.label }}
                                </div>
                                <img
                                    v-if="alerts && alerts.indexOf(item.value) > -1"
                                    src="../assets/images/icon_new.svg"
                                    class="app-cards-float-icon"
                                />
                            </v-card-title>
                        </v-img>
                    </v-card>
                </div>
            </div>
            <div v-if="apiFailed" class="app-error-info">
                <img src="../assets/images/icon_server_down.svg" />
                <div>
                    Parece que estamos a enfrentar alguns problemas ao estabelecer ligação com o servidor. Por favor, verifica a ligação à internet ou aguarda um pouco antes de tentar novamente.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Api from '../services/Api'
import Utils from '../services/Utils'

export default {
    data() {
        return {
            str: null,
            data: [],
            apiFailed: false,
            contentsConfig: null,
            hideTitle: null,
            notes: [],
            alerts: window.appCache && window.appCache.alertsNewContents ? window.appCache.alertsNewContents.map(a => a.type) : null,
        }
    },
    beforeMount: function () {
        this.main()
    },
    methods: {
        main: function () {
            const self = this
            Utils.refreshAppUrl()
            this.getStrings(function () {
                if (self.contentsConfig.design === 'pages') {
                    self.getTypes()
                } else {
                    const queryParams = { ...self.$route.query }
                    queryParams.filter = true
                    self.$router.push({
                        path: '/contents',
                        query: queryParams
                    })
                }
            })
        },
        getStrings: function (callback) {
            const self = this
            const str = Utils.getStrings(true)
            this.apiFailed = false
            if (str) {
                success(str)
            } else {
                Api.getStrings(function (response) {
                    if (response.success) {
                        Api.getEnums(function () {
                            Utils.setStrings(response.data)
                            success(response.data)
                        })
                    } else {
                        self.apiFailed = true
                    }
                })
            }

            function success(str) {
                self.contentsConfig = Utils.getContentsConfig()
                if (self.contentsConfig && self.contentsConfig.background) {
                    document.body.style.backgroundImage = 'url(' + self.contentsConfig.background + ')'
                }
                self.hideTitle = self.contentsConfig && self.contentsConfig.hide_title ? true : false
                self.notes = Utils.getContentNotes()
                self.str = str
                callback()
            }
        },
        getTypes: function () {
            this.data = Utils.getContentTypes()
            if (!this.data || (this.data && !this.data.length)) {
                const queryParams = { ...this.$route.query }
                this.$router.push({
                    path: '/contents',
                    query: queryParams
                })
            }
        },
        openItem: function (item) {
            const subTypes = Utils.getContentType()
            const queryParams = { ...this.$route.query }
            queryParams.type_label = item ? item.label : null
            queryParams.type_value = item ? item.value : null
            delete window.cache
            if (subTypes && subTypes[item.value] && subTypes[item.value].sub_types && subTypes[item.value].sub_types.length) {
                this.$router.push({
                    path: '/subtypes',
                    query: queryParams
                })
            } else {
                this.$router.push({
                    path: '/contents',
                    query: queryParams
                })
            }
        },
        back: function () {
            if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
                window.ReactNativeWebView.postMessage(JSON.stringify({
                    event: 'close'
                }))
            }
        },
        onEvents: function () {
            this.onBackEvent()
            this.onRefreshEvent()
        },
        offEvents: function () {
            this.offBackEvent()
            this.offRefreshEvent()
        },
        onBackEvent: function () {
            const self = this
            this.$root.$on('app-back', function () {
                self.back()
            })
        },
        offBackEvent: function () {
            this.$root.$off('app-back')
        },
        onRefreshEvent: function () {
            const self = this
            this.$root.$on('app-refresh', function () {
                self.alerts = window.appCache && window.appCache.alertsNewContents ? window.appCache.alertsNewContents.map(a => a.type) : null
            })
        },
        offRefreshEvent: function () {
            this.$root.$off('app-refresh')
        },
    },
    mounted () {
        this.onEvents()
    },
    beforeDestroy () {
        this.offEvents()
    }
}
</script>